import { configureStore } from "@reduxjs/toolkit";
import {
  induvidualProviderLangReducer,
  languageSuggestionReducer,
} from "./ProviderInfo/ProviderLanguageReducer";
import {
  providerEduTypeReducer,
  providerExpEducationReducer,
  providerOtherEduOptionReducer,
  providerAdvancedEduOptionReducer,
  providerOtherGraduateEduOptionReducer,
  providerDentalMedicalEduOptionReducer,
  providerEduInstitutionSearchReducer,
} from "./ProviderInfo/ProviderEducationReducer";
import {
  providerSPBDCertReducer,
  providerSpecilityReducer,
  SpecialitylanguageSuggestionReducer,
} from "./ProviderInfo/ProviderSpecialityReducer";
import {
  providerCertificationDetailsReducer,
  providerCertificationSuggestionReducer,
  deleteProviderCertificationReducer,
  saveProviderCertificationReducer,
} from "./Experience/GeneralCertificationReducer";
import {
  providerOverviewInformationReducer,
  providerOverviewPhotosReducer,
} from "./ProviderInfo/ProviderOverviewReducer";
import {
  photosListReducer,
  providerProfilePhotoReducer,
} from "./ProviderInfo/ProoviderPhotosReducer";
import {
  providerExpAssociationListReducer,
  providerExpAssociationReducer,
} from "./Experience/AssociationReducer";
import { providerLocationListReducer } from "./ProviderInfo/ProviderLocationReducer";
import {
  officeHoursReducer,
  updateOfficeHoursReducer,
} from "./Practice/OfficeHours/OfficeHoursReducer";
import {
  practiceAminitiesListReducer,
  practiceAminitiesCheckListReducer,
  practiceParkingOptionsListReducer,
  practiceParkingOptionsCheckListReducer,
} from "./PracticeInfo/AmenitiesReducer";
import {
  practiceLanguageSuggestionsReducer,
  practiceLanguagesReducer,
} from "./PracticeInfo/PracticeLanguageReducer";
import {
  providerLicenseTypeReducer,
  providerLicenseInformationReducer,
  providerLicenseMoreDetailsReducer,
  providerDisciplinaryMoreDetailsReducer,
} from "./ProviderInfo/ProviderLicenseReducer";
import {
  practiceInfoDetailsReducer,
  practiceInfoEmailDetailsReducer,
  practiceInfoPhoneFaxDetailsReducer,
} from "./PracticeInfo/PracticeInfoReducers";
import { practiceTechnologyListReducer } from "./PracticeInfo/TechnologyReducer";
import { practiceTechnologyCheckListReducer } from "./PracticeInfo/TechnologyReducer";
import {
  addPracticeInfoProvidersReducer,
  fetchReasonCodeActiveStatusReducer,
  fetchStatusUpdateReducer,
  practiceInfoProvidersReducer,
  searchProvidersReducer,
} from "./PracticeInfo/ProvidersDetailsReducers";
import {
  feeScheduleProviderDetailsReducer,
  feeSchedulePreferredNetworksReducer,
  feeSchedulesReducer,
  feeScheduleFormDetailsReducer,
} from "./Practice/FeeSchedule/feeScheduleReducers";
import {
  practiceServicesListReducer,
  practiceServicesChecklistReducer,
  practiceServicesListItemsReducer,
} from "./Practice/Services/ServicesReducer";
import {
  practiceAllFederalListReducer,
  practiceFederalReligiousDefaultReducer,
} from "./PracticeInfo/FederalReligiousReducer";
import { addPracticeDetailsReducer } from "./Admin/AddPracticeReducer";
import { practicePhotosReducer } from "./PracticeInfo/PracticePhotosReducer";
import {
  pinDetailsReducer,
  userDetailsReducer,
  userAccessReducer,
  inviteUserReducer,
  updateUserTypeReducer,
  accessCodeDetailsReducer,
  searchPracticeDetailsReducer,
  movePracticeDetailsReducer,
  resendInviteReducer,
} from "./ManageUser/manageUserReducer";
import {
  addProvidersCertifiedSpecialtyReducer,
  addProvidersDetailsReducer,
  addProvidersLicenseTypesReducer,
} from "./Admin/AddProvidersReducer";

import {
  practiceReviewProviderListReducer,
  practiceReviewsReducer,
  updateReviewReducer,
  updateReviewListsReducer,
} from "./Practice/Reviews/ReviewsReducers";
import {
  fetchUsersReducer,
  createUserReducer,
  updateUserReducer,
  resetPasswordReducer,
} from "./UserManagement/userManagementReducer";
import {
  myaccountLoginReducer,
  updateLoginInfoReducer,
  updateTokenReducer,
  updatePasswordReducer,
} from "./Myaccount/myaccountReducers";
import {
  dashboardDetailsReducer,
  dashboardStatsReducer,
} from "./dashboard/dashboardReducer";
import { practiceLocationReducer } from "./ProviderInfo/PracticeLocationReducers";
import { contactUsReducer } from "./dashboard/ContactUsReducer";
import {
  providerSearchSuggestionReducer,
  practiceSearchSuggestionReducer,
} from "./Searchlist/SearchListReducer";
import { addAgesTreatedAPIReducer } from "./dashboard/AddAgesTreatedReducer";
import {
  brighterScoreCarrierApiReducer,
  brighterScoreReducer,
} from "./dashboard/BrightScoreReducer";
import {
  providerStatusReducers,
  providerStatusUpdateReducers,
} from "./Status/ProviderStatusReducers";
import {
  practiceStatusReducers,
  practiceStatusUpdateReducers,
} from "./Status/PracticeStatusReducers";
import { myPracticeReducer } from "./MyPractice/MyPracticeReducer";
import {
  providerForgotPasswordReducer,
  providerLoginAuthenticateReducer,
  providerPinVerificationReducer,
  providerUserDetailsReducer,
} from "./Login/LoginReducer";

const store = configureStore({
  reducer: {
    induvidualProviderLang: induvidualProviderLangReducer,
    langSuggestion: languageSuggestionReducer,
    providerOverviewInformation: providerOverviewInformationReducer,
    providerSpeciality: providerSpecilityReducer,
    SpecialitylangSuggestion: SpecialitylanguageSuggestionReducer,
    providerCertificationSuggesions: providerCertificationSuggestionReducer,
    saveProviderCertifications: saveProviderCertificationReducer,
    providerCertificationDetails: providerCertificationDetailsReducer,
    deleteProviderCertification: deleteProviderCertificationReducer,
    providerSPBDCertificate: providerSPBDCertReducer,
    providerExperienceEducation: providerExpEducationReducer,
    providerEduType: providerEduTypeReducer,
    providerOtherEduOption: providerOtherEduOptionReducer,
    providerAdvancedEduOption: providerAdvancedEduOptionReducer,
    providerUnderGraduateEduOption: providerOtherGraduateEduOptionReducer,
    providerDentalMedicalEduOption: providerDentalMedicalEduOptionReducer,
    providerEduInstitutionSearch: providerEduInstitutionSearchReducer,
    providerPhotosList: photosListReducer,
    providerProfilePhoto: providerProfilePhotoReducer,
    associationSuggestion: providerExpAssociationReducer,
    expassociationList: providerExpAssociationListReducer,
    providerLocationData: providerLocationListReducer,
    officeHours: officeHoursReducer,
    updateOfficeHours: updateOfficeHoursReducer,
    practiceAminitiesList: practiceAminitiesListReducer,
    practiceAminitiesCheckList: practiceAminitiesCheckListReducer,
    providerLicenseTypesSuggestions: providerLicenseTypeReducer,
    providerLicenseInformation: providerLicenseInformationReducer,
    practiceInfoDetails: practiceInfoDetailsReducer,
    practiceInfoPhoneFaxDetails: practiceInfoPhoneFaxDetailsReducer,
    practiceInfoEmailDetails: practiceInfoEmailDetailsReducer,
    practiceLanguageSuggestions: practiceLanguageSuggestionsReducer,
    practiceLanguages: practiceLanguagesReducer,
    practiceTechnologyList: practiceTechnologyListReducer,
    practiceTechnologyCheckList: practiceTechnologyCheckListReducer,
    providerLicenseMoreDetails: providerLicenseMoreDetailsReducer,
    providerDisciplinaryMoreDetails: providerDisciplinaryMoreDetailsReducer,
    practiceInfoProvidersDetails: practiceInfoProvidersReducer,
    searchProvidersData: searchProvidersReducer,
    feeScheduleProviderDetails: feeScheduleProviderDetailsReducer,
    preferredNetworks: feeSchedulePreferredNetworksReducer,
    feeSchedules: feeSchedulesReducer,
    feeScheduleFormDetails: feeScheduleFormDetailsReducer,
    practiceServicesList: practiceServicesListReducer,
    practiceServicesChecklist: practiceServicesChecklistReducer,
    practiceServicesListItems: practiceServicesListItemsReducer,
    allListFederalReligious: practiceAllFederalListReducer,
    defaultFederalReligious: practiceFederalReligiousDefaultReducer,
    practicePhotos: practicePhotosReducer,
    addPracticeData: addPracticeDetailsReducer,
    pinDetails: pinDetailsReducer,
    userDetails: userDetailsReducer,
    userAccess: userAccessReducer,
    inviteUser: inviteUserReducer,
    updateUserType: updateUserTypeReducer,
    accessCodeDetails: accessCodeDetailsReducer,
    searchPracticeDetails: searchPracticeDetailsReducer,
    movePracticeDetails: movePracticeDetailsReducer,
    resendInvite: resendInviteReducer,
    practiceReviewList: practiceReviewsReducer,
    providersListItem: practiceReviewProviderListReducer,
    updateReview: updateReviewReducer,
    updateReviewLists: updateReviewListsReducer,
    addProvidersLicenseTypes: addProvidersLicenseTypesReducer,
    addProvidersCertifiedSpecialty: addProvidersCertifiedSpecialtyReducer,
    addProviders: addProvidersDetailsReducer,
    myaccountLoginInformation: myaccountLoginReducer,
    createUser: createUserReducer,
    updateUser: updateUserReducer,
    fetchUsers: fetchUsersReducer,
    resetPassword: resetPasswordReducer,
    updateLoginInfo: updateLoginInfoReducer,
    updateToken: updateTokenReducer,
    updatePassword: updatePasswordReducer,
    dashboardStats: dashboardStatsReducer,
    dashboardDetails: dashboardDetailsReducer,
    practiceLocationDetails: practiceLocationReducer,
    contactUs: contactUsReducer,
    providerSearchSuggestion: providerSearchSuggestionReducer,
    practiceSearchSuggestion: practiceSearchSuggestionReducer,
    addAgesTreated: addAgesTreatedAPIReducer,
    brighterScoreData: brighterScoreReducer,
    practiceParkingOptionsList: practiceParkingOptionsListReducer,
    practiceParkingOptionsCheckList: practiceParkingOptionsCheckListReducer,
    addPracticeInfoProviders: addPracticeInfoProvidersReducer,
    reasonCodeActive: fetchReasonCodeActiveStatusReducer,
    providersStatus: fetchStatusUpdateReducer,
    providerOverviewPhotos: providerOverviewPhotosReducer,
    brighterScoreCarrierData: brighterScoreCarrierApiReducer,
    providerStatus: providerStatusReducers,
    providerStatusUpdate: providerStatusUpdateReducers,
    practiceStatus: practiceStatusReducers,
    practiceStatusUpdate: practiceStatusUpdateReducers,
    myPractice: myPracticeReducer,
    loginAuth: providerLoginAuthenticateReducer,
    pinVerification: providerPinVerificationReducer,
    forgotPassword: providerForgotPasswordReducer,
    loginUserDetails: providerUserDetailsReducer,
  },
});

export default store;
